import cn from 'classnames';
import * as React from 'react';

import BaseClickable, { BaseClickableProps, ValueProp } from 'components/ui/BaseClickable';
import Loader from 'components/ui/Loader';
import { WithTooltip } from 'components/ui/ToolTip';
import { IconProps } from 'hocs/withIconWrapper';
import { useRem } from 'hooks/useRem';

import s from './IconButton.module.scss';

type IconButtonProps<Value extends ValueProp> = {
  Icon: React.FC<IconProps>;
  caption?: string;
  isLoading?: boolean;
  className?: string;
  iconSize?: string;
} & BaseClickableProps<Value>;

const IconButton = <Value extends ValueProp>({
  Icon,
  iconSize,
  caption,
  isLoading,
  className,
  ...props
}: IconButtonProps<Value>) => {
  const calcRem = useRem();

  if (!caption) {
    return (
      <BaseClickable className={cn(s.root, className)} {...props}>
        {isLoading ? <Loader /> : <Icon size={iconSize ?? calcRem({ desktop: 24 })} />}
      </BaseClickable>
    );
  }

  return (
    <WithTooltip className={cn(s.root, className)} text={caption} offset={0}>
      <BaseClickable {...props}>
        {isLoading ? <Loader /> : <Icon size={iconSize ?? calcRem({ desktop: 24 })} />}
      </BaseClickable>
    </WithTooltip>
  );
};

export default IconButton;
